import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { BrandLogo } from '../../atoms/brand-logo/brand-logo';

@Component({
  selector: 'om-app-loading-screen',
  imports: [BrandLogo],
  templateUrl: './app-loading-screen.html',
  styleUrl: './app-loading-screen.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLoadingScreen {
  private readonly translate = inject(TranslateService);
  private readonly translationVersion = signal(0);

  messageKey = input('APP.LOADING.MESSAGE');
  fallbackMessage = input('Cargando tu espacio emocional...');
  logoHeightClass = input('h-14');

  readonly resolvedMessage = computed(() => {
    this.translationVersion();
    const key = this.messageKey();
    const translated = this.translate.instant(key);
    if (translated && translated !== key) return translated;
    return this.fallbackForLanguage();
  });

  constructor() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(() =>
        this.translationVersion.update((version) => version + 1)
      );

    this.translate.onTranslationChange
      .pipe(takeUntilDestroyed())
      .subscribe(() =>
        this.translationVersion.update((version) => version + 1)
      );
  }

  private fallbackForLanguage(): string {
    const lang = (
      this.translate.currentLang ||
      this.translate.defaultLang ||
      'es'
    ).toLowerCase();

    if (lang.startsWith('en')) {
      return 'Loading your emotional space...';
    }
    if (lang.startsWith('pt')) {
      return 'Carregando seu espaço emocional...';
    }
    return this.fallbackMessage();
  }
}
